import * as React from "react";
import { Modal,Button} from "antd";
import { connect } from "react-redux";
import { getOldHost } from "utils/tool";

interface IConfirmationProps {
  id:any;
  downloadjpg:any;
}

// 确认函
class Confirmation extends React.Component<IConfirmationProps, any> {
  state = {
    visible:false,
  };
  constructor(props: IConfirmationProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  download= () => {
    const param: any = {
      id: this.props.id
    }; 
    this.props.downloadjpg({
      ...param,
      callback: (data) => {
         //console.log(data);
          window.location.href = data.attachment;
      }
     }); 
  }

  render() {
    let url = getOldHost()+"/api/confirmation/index/"+this.props.id;
   // let downurl = getOldHost()+"/api/confirmation/download_jpg/"+this.props.id;
    return (
      <React.Fragment>
      <Button onClick={this.show.bind(this,this.props.id)}>查看确认单</Button> 
      <Modal maskClosable={false} onCancel={this.handleCancel} title="查看确认函" visible={this.state.visible} footer={null} width="auto" centered={true}>
      <div className="frame-content">
      <iframe frameBorder="0" scrolling="auto" src={url} />
      </div>
      <div className="down-confirmation">
      <Button type="primary"  icon="download" onClick={this.download} >下载此确认函</Button>
      </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    downloadjpg: dispatch.orderDetails.downloadjpg
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Confirmation);
